import React from 'react';
import { useSelector } from 'react-redux';
import InformativeCard from '../../../components/InformativeCard/InformativeCard';
import accreditationRequiredLogo from '../../../assets/img/other/accreditation-required-logo.svg';
import SecuritizePage from '../../../components/SecuritizePage';

const AccreditationRequired = () => {
  const { config: { securitizeIdUrl, nieHost } } = useSelector(({ issuerConfiguration }) => issuerConfiguration);
  const { isLoading, isError } = useSelector(({ investorQualification }) => investorQualification);

  const getAccredited = () => {
    window.location.href = `${securitizeIdUrl}/accreditation?redirectUrl=${encodeURIComponent(nieHost)}`;
  };

  const contactUs = () => {
    window.location.href = `mailto:${process.env.CONTACT_EMAIL}`;
  };

  return (
    <SecuritizePage isLoading={isLoading} isError={isError}>
      <InformativeCard
        img={accreditationRequiredLogo}
        title="Texts.accreditation-required"
        description="Texts.accreditation-required.description"
        warningMsg="Texts.information-required"
        primaryBtn="Texts.get-accreditated"
        secondaryBtn="Texts.contact-us"
        primaryOnClick={getAccredited}
        secondaryOnClick={contactUs}
      />
    </SecuritizePage>
  );
};

export default AccreditationRequired;
